import { Pipe, PipeTransform } from '@angular/core';
/*
 * Raise the value exponentially
 *
 * Usage:
 *   section | sectionname
 * Example:
 *   {{ "CERTIFICATION_GENERAL" | sectionname }}
 *   return -> General Certification
*/
@Pipe({name: 'sectionname'})
export class SectionNamePipe implements PipeTransform {
  transform(value: string): string {
    let section="";
    let sections:any={
        CERTIFICATION_GENERAL:"General Certification",
        ACCOUNT_GENERAL:"General Account",
        CERTIFICATION_ACHIEVEMENT:"Achievement Certification",
        FINANCE_COST:"Cost Finance",
        FINANCE_GENERAL:"General Finance",
        IDENTIFICATION_GENERAL: "General Identification",
        OPERATIONS_DOMAIN:"Domain Operations",
        OPERATIONS_GENERAL:"General Operations",
        OPERATIONS_KPI:"KPI",
        OPERATIONS_ORGANIZATIONCHART:"Organization-chart",
        PROFILE_COMPANY:"Company Profiles",
        PROFILE_PERSONAL:"Personal Profile",
        PROFILE_WORKINGHOURS:"Working Hours",
        RELATIONSHIP_EMPLOYEE:"Employees",
        RELATIONSHIP_SUPPLIER:"Suppliers"
    }
    Object.keys(sections).forEach(sect=>{
       if(sect==value)
            section = sections[sect];
    });

    return section?section:value;
  }
}